<template>
  <v-layout row wrap justify-center align-center no-gutters>
    <v-toolbar
      color="#2470d0"
      height="40px"
      dark
      class="text-center d-flex justify-left align-left cont-menu-black"
    >
      <a href="https://www.gov.co/" target="_blank">
        <img src="@/assets/img/marcapais-gov.svg" width="100px" alt="">
      </a>
    </v-toolbar>

    <v-flex xs12 v-if="!$vuetify.breakpoint.xs">
      <v-toolbar
        color="#383838"
        height="40px"
        dark
        class="text-center d-flex justify-center align-center cont-menu-black"
      >
        <template v-for="(item, idx) in itemsMenu">
          <v-btn
            v-if="item.subitems_menu.length <= 0"
            :key="'itemMenu-'+idx"
            text
            :href="item.url_menu"
            target="_blank"
            @click="navegarA($event, item)"
            class="btn-itemh"
            dark
          >
            {{ item.nombre_menu }}
          </v-btn>

          <v-menu
            v-else
            :key="'itemMenu-menu-'+idx"
            nudge-top="0"
            offset-y
            transition="slide-y-transition"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                text
                v-bind="attrs"
                v-on="on"
                dark
                class="btn-itemh"
              >
                <span>{{ item.nombre_menu }}</span>
                <v-icon right>mdi-menu-down</v-icon>
              </v-btn>
            </template>
            <v-list flat>
              <v-list-item
                v-for="(childItem, idxChild) in item.subitems_menu"
                :key="'childItem-'+idxChild"
                class="px-2 py-0 cont-item-menu"
                :href="childItem.url_menu"
                target="_blank"
                @click="navegarA($event, childItem)"
              >
                <v-list-item-content>
                  <v-list-item-title class="texto-menu" color="textprimary">
                    {{ childItem.nombre_menu }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-menu>
        </template>

        <v-btn
          dark
          text
          class="btn-itemh"
          @click.stop="drawer = !drawer"
        >
          Accesibilidad
        </v-btn>
      </v-toolbar>
    </v-flex>

    <v-menu
      v-else
      bottom
      origin="center center"
      transition="scale-transition"
      overlay
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          v-if="$vuetify.breakpoint.xs"
          fab
          color="#DDDDDD"
          elevation="0"
          v-bind="attrs"
          v-on="on"
          class="boton-flotando"
          x-small
          depressed
        >
          <v-icon>mdi-cog</v-icon>
        </v-btn>
      </template>
      <v-list>
        <template v-for="(item, idx) in itemsMenu">
          <v-list-item
            v-if="item.subitems_menu.length <= 0"
            :key="'itemMenu-mob-'+idx"
            text
            :href="item.url_menu"
            target="_blank"
            @click="navegarA($event, item)"
            class="cont-item-menu"
          >
            <v-list-item-title class="font-small d-flex align-center">
              {{ item.nombre_menu }}
              <v-icon class="ml-auto">mdi-chevron-right</v-icon>
            </v-list-item-title>
          </v-list-item>

          <v-list-item v-else :key="'itemMenu-mob-sub-'+idx">
            <v-list-item-content>
              <v-list-item-title class="font-small">{{ item.nombre_menu }}</v-list-item-title>
              <v-divider></v-divider>
              <v-list flat>
                <v-list-item
                  v-for="(childItem, idxChild) in item.subitems_menu"
                  :key="'childItem-mob-'+idxChild"
                  class="px-2 py-0 cont-item-menu"
                  :href="childItem.url_menu"
                  target="_blank"
                  @click="navegarA($event, childItem)"
                >
                  <v-list-item-title class="font-small d-flex align-center">
                    {{ childItem.nombre_menu }}
                    <v-icon class="ml-auto">mdi-chevron-right</v-icon>
                  </v-list-item-title>
                </v-list-item>
              </v-list>
            </v-list-item-content>
          </v-list-item>
        </template>
      </v-list>
    </v-menu>

    <v-navigation-drawer
      v-model="drawer"
      fixed
      temporary
      right
      hide-overlay
    >
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title>Menú de accesibilidad</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-divider></v-divider>
      <v-list dense>
        <v-list-item @click="accionItem('aumentarTexto'), verresblecer = true">
          <v-list-item-icon>
            <v-icon>mdi-format-annotation-plus</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Aumentar texto</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item v-if="verresblecer" @click="accionItem('reducirTexto')">
          <v-list-item-icon>
            <v-icon>mdi-format-annotation-minus</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Ruducir texto</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item v-if="verresblecer" @click="accionItem('restablecerTexto'), verresblecer = false">
          <v-list-item-icon>
            <v-icon>mdi-format-text-variant</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Restablecer texto</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>
              <v-switch
                light
                label="Modo oscuro"
                @change="toggleDarkTheme()"
              ></v-switch>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
  </v-layout>
</template>

<script>
import axios from 'axios'

export default {
  data () {
    return {
      drawer: false,
      verresblecer: false,
      itemsMenu: []
    }
  },
  async created () {
    await axios
      .get('' + this.$store.state.rutaApi + 'menu_inicial')
      .then(response => (this.itemsMenu = response.data[0].elementos))
  },
  methods: {
    navegarA (e, item) {
      if (!item || !item.url_menu) return
      const url = item.url_menu.trim()

      if (url.includes('#/')) {
        if (e && e.preventDefault) e.preventDefault()
        const rutaInterna = url.split('#')[1]
        const urlParts = rutaInterna.split('/')
        const nuevoId = urlParts[2]
        if (nuevoId) {
          this.$store.commit('SETIDCONTENIDO', nuevoId)
        }
        if (this.$route.path !== rutaInterna) {
          this.$router.push(rutaInterna).catch(() => {})
        }
        return
      }

      if (url.startsWith('http://') || url.startsWith('https://') || url.startsWith('//')) {
        if (!e || !e.target || e.defaultPrevented) {
          window.open(url, '_blank')
        }
        return
      }

      if (e && e.preventDefault) e.preventDefault()
      const ruta = url.startsWith('/') ? url : '/' + url
      if (this.$route.path !== ruta) {
        this.$router.push(ruta).catch(() => {})
      }
    },
    accionItem (val) {
      this.$emit('accionAcce', val)
    },
    toggleDarkTheme () {
      this.$vuetify.theme.dark = !this.$vuetify.theme.dark
    }
  }
}
</script>

<style lang="scss" scoped>
.btn-itemh{
  max-height: 40px;
  font-size: 0.7em!important;
  font-weight: 800;
  padding: 0px 6px!important;
}
.cont-logo{
  cursor: pointer;
  padding: 15px 10px 5px 10px;
  border-radius:0px 0px 5px 5px;
  background: white;
  margin-top: 20px;
  margin-right: 10px;
  box-shadow: 0px 4px 10px 1px rgba(0, 0, 0, 0.3);
  img{
    width: 140px;
  }
}
.itemHorizonal{
  display: inline-block;
}
.bdred{
  border: solid red 1px;
}
.texto-menu{
  font-size: 1em;
  color: var(--v-primary-base);
  font-weight: 600;
}
.cont-item-menu{
  min-height: 30px!important;
}
.boton-menu{
  padding: 0px 5px!important;
  min-width: 30px;
  letter-spacing: 0;
}
.boton-flotando{
  position: fixed;
  top: 2px;
  right: 2px;
  z-index: 3;
}
</style>